import { render } from "./Payment.vue?vue&type=template&id=2bdd5e92&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=2bdd5e92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdd5e92"],['__file',"src/views/Home/MakeAppointment/Payment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bdd5e92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bdd5e92', __exports__)) {
    console.log('reload')
    api.reload('2bdd5e92', __exports__)
  }
  
  module.hot.accept("./Payment.vue?vue&type=template&id=2bdd5e92&scoped=true", () => {
    console.log('re-render')
    api.rerender('2bdd5e92', render)
  })

}


export default __exports__